<template>
  <f7-page>
    <navbar :text="$t('AnnualBudgets_Title')" />
    <DxAnnualBudgets />
  </f7-page>
</template>

<script>

import DxAnnualBudgets from '../../components/Planning/DxAnnualBudgets.vue';
import navbar from '../../components/NavBar.vue';

export default {
  components: {
    DxAnnualBudgets,
    navbar,
  },
};
</script>

<style>

</style>
